export interface TickerItem {
  activity_time: string
  activity_status: string
  sort: number
}

export interface HourlyTicker {
  prev: number
  current: number
  hour: number
}

export interface CurrentActivityState {
  APPOINTMENTS_SET: number | null
  APPOINTMENTS_SET_PERCENT_CHANGE: number | null
  TOTAL_CALLS: number | null
  TOTAL_CALLS_PERCENT_CHANGE: number | null
  TOTAL_CHATS_TEXTS: number | null
  TOTAL_CHATS_TEXTS_PERCENT_CHANGE: number | null
  COHORT: string
  COHORT_TYPE: string
  DBT_UPDATED_AT: string
  APPOINTMENT_SET_TICKER_ARRAY: TickerItem[]
  PRIOR_WEEK_APPOINTMENT_SET_TICKER_ARRAY: TickerItem[]
  CALLS_TICKER_ARRAY: TickerItem[] | null
  CHATS_TEXTS_TICKER_ARRAY: null | TickerItem[]
  LEADS_BY_CHANNEL: {
    paid: number
    paid_pct_change: number
    non_paid: number
    non_paid_pct_change: number
    third_party: number
    third_party_pct_change: number
  }
  WEB_VISITORS: null | number
  WEB_VISITORS_PERCENT_CHANGE: number
  WEB_VISITORS_PREV?: number
  HOURLY_LEADS_ARRAY: HourlyTicker[]
  LEADS: number
  LEADS_PERCENT_CHANGE: number
  HOURLY_WEB_VISITORS_ARRAY: HourlyTicker[]
  TIMEFRAME: string
}

export const ACTIVITY_TIMEFRAMES = {
  today: 'Today',
  yesterday: 'Yesterday',
  prev_week: 'Same day last week'
}
